<!-- Ported from the Polaris kit: src/components/ui/marker/MarkerIcon.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { cn } from '../../lib/utils';

const props = defineProps({
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});
</script>

<template>
  <span
    data-slot="marker-icon"
    aria-hidden="true"
    :class="
      cn(
        `size-4 [&_svg:not([class*='size-'])]:size-4 shrink-0 p-0`,
        props.class
      )
    "
  >
    <slot />
  </span>
</template>
